/** @format */

import React from "react";
import "./App.css";
import Routes from "./components/layouts/routes";

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
